import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, BarChart, Bar, XAxis, YAxis, CartesianGrid, Legend } from 'recharts';

const COLORS = {
  interest: '#3498db',
  emotion: '#e74c3c',
  social: '#f39c12',
  other: '#95a5a6'
};

export const InsightTypePieChart = ({ data, onTypeClick, selectedType }) => {
  // Convert object to array format for recharts
  const chartData = Object.entries(data)
    .filter(([type, count]) => count > 0) // Only show types with data
    .map(([type, count]) => ({
      name: type.charAt(0).toUpperCase() + type.slice(1),
      value: count,
      type: type
    }));

  if (chartData.length === 0) {
    return (
      <div style={{
        height: 250,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#999'
      }}>
        No insights data yet
      </div>
    );
  }

  const handleClick = (data) => {
    if (onTypeClick) {
      onTypeClick(data.type);
    }
  };

  return (
    <ResponsiveContainer width="100%" height={250}>
      <PieChart>
        <Pie
          data={chartData}
          cx="50%"
          cy="50%"
          labelLine={false}
          label={({name, percent}) => `${name} ${(percent * 100).toFixed(0)}%`}
          outerRadius={80}
          fill="#8884d8"
          dataKey="value"
          onClick={handleClick}
          style={{ cursor: 'pointer' }}
        >
          {chartData.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={COLORS[entry.type]}
              opacity={selectedType && selectedType !== entry.type ? 0.3 : 1}
            />
          ))}
        </Pie>
        <Tooltip />
      </PieChart>
    </ResponsiveContainer>
  );
};

export const DailyActivityChart = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div style={{
        height: 250,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#999'
      }}>
        No activity data yet
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={250}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="day" />
        <YAxis allowDecimals={false} />
        <Tooltip
          content={({ active, payload }) => {
            if (active && payload && payload.length) {
              return (
                <div style={{
                  background: 'white',
                  padding: '8px 12px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  fontSize: '14px'
                }}>
                  <p style={{ margin: 0, fontWeight: 'bold' }}>{payload[0].payload.date}</p>
                  <p style={{ margin: '4px 0 0 0', color: '#667eea' }}>
                    {payload[0].value} insight{payload[0].value !== 1 ? 's' : ''}
                  </p>
                </div>
              );
            }
            return null;
          }}
        />
        <Bar dataKey="count" fill="#667eea" radius={[8, 8, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};

// Keep WeeklyTrendChart as alias for backwards compatibility
export const WeeklyTrendChart = DailyActivityChart;
